module.exports = __webpack_public_path__ + "static/media/icono_comercio exterior.f57bf663.png";